





import React, {useState} from 'react';

import "./LoginWhole.css"
import Login from '../Login/Login';
import Footer from '../../Components/Footer/Footer';




function LoginWhole() { 
 

  return <>
        <div className='LoginWholeContainer'>   

                <Login/>
                <Footer/>

        </div>
       
    
  </>
  
  ;
}

export default LoginWhole;